import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

import { NgChartsModule } from 'ng2-charts';

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MY_DATE_FORMAT } from 'src/app/components/configurations/date-format-configuration';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { EmptyStateComponent } from 'src/app/components/empty-state/empty-state.component';
import { FdBarChartComponent } from 'src/app/components/fd-bar-chart/fd-bar-chart.component';
import { FdCalendarComponent } from 'src/app/components/fd-calendar/fd-calendar.component';
import { FdChipCollectionComponent } from 'src/app/components/fd-chip-collection/fd-chip-collection.component';
import { FdChipComponent } from 'src/app/components/fd-chip/fd-chip.component';
import { FdCyclePotentialComponent } from 'src/app/components/fd-cycle-potential/fd-cycle-potential.component';
import { FdFilterComponent } from 'src/app/components/fd-filter/fd-filter.component';
import { FdFlipIconComponent } from 'src/app/components/fd-flip-icon/fd-flip-icon.component';
import { FdImplementationStatusComponent } from 'src/app/components/fd-implementation-status/fd-implementation-status.component';
import { FdIsCardComponent } from 'src/app/components/fd-is-card/fd-is-card.component';
import { FdMapComponent } from 'src/app/components/fd-map/fd-map.component';
import { FdMarketsCpComponent } from 'src/app/components/fd-markets-cp/fd-markets-cp.component';
import { FdSearchFieldComponent } from 'src/app/components/fd-search-field/fd-search-field.component';
import { FdSelectComponent } from 'src/app/components/fd-select/fd-select.component';
import { CommonModule } from '@angular/common';
import { MecsMapComponent } from 'src/app/components/mecs-map/mecs-map.component';
import { MecsKpiFilterComponent } from 'src/app/components/mecs-kpi-filter/mecs-kpi-filter.component';
import { MecsImplementationStatusComponent } from 'src/app/components/mecs-implementation-status/mecs-implementation-status.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MecsInDepthFilterComponent } from 'src/app/components/mecs-in-depth-filter/mecs-in-depth-filter.component';

@NgModule({
  declarations: [
    FdMapComponent,
    FdIsCardComponent,
    FdFilterComponent,
    MecsMapComponent,
    FdSelectComponent,
    FdChipComponent,
    FdCalendarComponent,
    FdCyclePotentialComponent,
    FdFlipIconComponent,
    FdSearchFieldComponent,
    FdChipCollectionComponent,
    FdImplementationStatusComponent,
    FdBarChartComponent,
    FdMarketsCpComponent,
    EmptyStateComponent,
    MecsKpiFilterComponent,
    MecsImplementationStatusComponent,
    MecsInDepthFilterComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatStepperModule,
    NgChartsModule,
    MatTableModule,
    MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatPaginatorModule,
  ],
  exports: [
    MecsMapComponent,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatStepperModule,
    NgChartsModule,
    MatTableModule,
    MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    FdMapComponent,
    FdIsCardComponent,
    FdFilterComponent,
    FdSelectComponent,
    FdChipComponent,
    FdCalendarComponent,
    FdCyclePotentialComponent,
    FdFlipIconComponent,
    FdSearchFieldComponent,
    FdChipCollectionComponent,
    FdImplementationStatusComponent,
    FdBarChartComponent,
    FdMarketsCpComponent,
    EmptyStateComponent,
    MecsKpiFilterComponent,
    MecsImplementationStatusComponent,
    MecsInDepthFilterComponent,
    MatPaginatorModule,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ],
})
export class SharedModule {}
